import Footer from "./Footer";
import LandHeader from "./LandHeader";
import { Link } from "react-router-dom";
import { useMediaQuery } from "beautiful-react-hooks";
import { useEffect, useState } from "react";
import axios from "axios";
import { MdContentCopy } from "react-icons/md";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import SimpleAccordion from "./SimpleAccordion";

const data = [
  {
    queOne: "با جایزه و کمپین کارمزد صفر، سینا تتر چگونه سود می‌کند؟",
    ansOne:
      "خوب است بدانید این جایزه و کمپین کارمزد صفر، علاوه بر درنظر گرفتن رفاه حال مشتریان، باعث افزایش درآمد سینا تتر نیز می‌شود؛ چرا که مانند سایر صرافی ها، سود sinatether نیز از اختلاف قیمت خرید و فروش حاصل شده و در واقع با جایزه، فرصتی مناسب را برای کاربران فراهم آورده و از طرف دیگر با افزایش مشتریان و حاشیه سود کمتر، به کسب و کار خود رونق می‌بخشد.",
  },
  {
    queOne: "آیا جایزه های صرافی سینا تتر ثابت است؟        ",
    ansOne:
      "به عبارت بهتر اگر بخواهیم بگوییم، جوایز ما بیشتر متنوع است و همیشه سعی داریم تا با استفاده از تنوع رمز ارزی بالایی که داریم، همواره گزینه‌های جذاب‌تری را بیش روی شما بگذاریم.        ",
  },
];

export default function GiftPage() {
  const isSmall = useMediaQuery("(max-width: 768px)");

  const [Auth, setAuth] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const [inviteLink, setInviteLink] = useState("");

  document.title = "صرافی جایزه دار سینا تتر";
  document.getElementsByTagName("META")[3].content =
    "صرافی جایزه دار سینا تتر با تنوع ارزی بالا و جوایز متنوع که به صورت دوره‌ای بروز رسانی می شوند، علاوه بر رمز ارز، خدمات دیگری مانند کارمزد صفر نیز دارد.";

  const onCopyText = () => {
    setIsCopied(true);
    toast.dismiss();

    toast.warning(" کپی شد!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  var canonical = document.querySelector('link[rel="canonical"]');
  if (canonical !== null) {
    canonical.href = `https://sinatether.com/prize-exchange`;
  }

  useEffect(() => {
    axios
      .get("https://api.sinatether.com/Auth/GetDetailsAccount", {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status == 200) {
          setAuth(true);
          setInviteLink(res.data["ref"]);
        }
      })
      .catch((error) => {
        setAuth(false);
      });
  }, []);

  return (
    <div id="main-wrapper" className={"show"}>
      <LandHeader />

      {isSmall ? (
        <>
          <div className="gift2023">
            <div className="submobgif2023">
              <div className="jfsfs-242424">
                <div>
                  <h2 className="h2-gift">صرافی جایزه دار</h2>

                  <p className="pgift2023">
                    سینا تتر برای رقابت در بازار رمز ارزها، به عنوان یک صرافی
                    جایزه دار از سرمایه گذاری تمامی افراد حمایت می‌کند.
                  </p>

                  {Auth ? (
                    <Link to={"/ehraz"}>
                      <button className="btn2j-gift">احراز هویت</button>
                    </Link>
                  ) : (
                    <Link to={"/login"}>
                      <button className="btn2j-gift">ورود</button>
                    </Link>
                  )}
                </div>
              </div>

              <div className="">
                <img
                  src="https://static.sinatether.com/images/gift2023.svg"
                  alt="صرافی جایزه دار سینا تتر "
                />
              </div>
            </div>

            <div className=" items-sub-gift2023">
              <div className=" marginrl-14">
                <div className="">
                  <div className="card-gift2023">
                    <img
                      className="img-gift-size"
                      src="https://static.sinatether.com/images/gift1.svg"
                      alt="بیبی دوج رایگان با ثبت نام در سینا تتر | تتر رایگان | ارز دیجیتال رایگان در سینا تتر"
                    />

                    <div className="title-gift2023">ثبت نام کن!</div>

                    <p className="ksjfsf242929451">
                      با ثبت نام در سینا تتر 200 میلیون بیبی دوج جایزه ببر.
                    </p>

                    {Auth ? (
                      <Link to={"/ehraz"}>
                        <button className="btngift">احراز هویت</button>
                      </Link>
                    ) : (
                      <Link to={"/login"}>
                        <button className="btngift">ثبت نام</button>
                      </Link>
                    )}
                  </div>
                </div>

                <div className=" ">
                  <div className="card-gift2023">
                    <img
                      className="img-gift-size"
                      src="https://static.sinatether.com/images/gift2.svg"
                      alt="خرید ارز دیجیتال بدون کارمزد در سینا تتر | خرید ارز دیجیتال با کمترین کارمزد"
                    />

                    <div className="title-gift2023">ارز بدون کارمزد بخر!</div>

                    <p className="ksjfsf242929451">
                      شما میتوانی تمامی ارز هارا در سینا تتر بدون کارمزد بخرید.
                    </p>
                    <Link to={"/BTC"}>
                      <button className="btngift">معامله</button>
                    </Link>
                  </div>
                </div>

                <div className=" ">
                  <div className="card-gift2023">
                    <img
                      className="img-gift-size"
                      src="https://static.sinatether.com/images/gift3.svg"
                      alt="درآمد رایگان با دعوت از دوستان در سینا تتر"
                    />

                    <div className="title-gift2023">دوستاتو دعوت کن! </div>

                    <p className="ksjfsf242929451">
                      با ارسال لینک دعوت به دوستان خود 200 هزار په په رایگان از
                      سینا تتر بگیر.{" "}
                    </p>

                    {Auth ? (
                      <>
                        <CopyToClipboard text={inviteLink} onCopy={onCopyText}>
                          <div className={"fhjshfcopy"}>
                            <MdContentCopy />
                          </div>
                        </CopyToClipboard>

                        <div className="kfjsfn24253">{inviteLink}</div>
                      </>
                    ) : (
                      <Link to={"/login"}>
                        <button className="btngift">دریافت لینک دعوت</button>
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              <div className="  marginrl-14 hjfdsgbf24232">
                <SimpleAccordion data={data} />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="gift2023">
            <div className="row marginrl-140">
              <div className="col-6 jfsfs-242424">
                <div>
                  <h2 className="h2-gift">صرافی جایزه دار</h2>

                  <p className="hdfsbfsfonr123">
                    سینا تتر برای رقابت در بازار رمز ارزها،
                    <br />
                    به عنوان یک صرافی جایزه دار از سرمایه گذاری تمامی افراد
                    حمایت می‌کند.
                    <br />
                  </p>

                  {Auth ? (
                    <Link to={"/ehraz"}>
                      <button className="btn2j-gift">احراز هویت</button>
                    </Link>
                  ) : (
                    <Link to={"/login"}>
                      <button className="btn2j-gift">ورود</button>
                    </Link>
                  )}
                </div>
              </div>

              <div className="col-6">
                <img
                  src="https://static.sinatether.com/images/gift2023.svg"
                  alt="صرافی جایزه رایگان "
                />
              </div>
            </div>

            <div className=" items-sub-gift2023">
              <div className="row marginrl-140 ">
                <div className="col-4  ">
                  <div className="card-gift2023">
                    <img
                      className="img-gift-size"
                      src="https://static.sinatether.com/images/gift1.svg"
                      alt=""
                    />

                    <div className="title-gift2023">ثبت نام کن!</div>

                    <p className="ksjfsf242929451">
                      با ثبت نام در سینا تتر 200 میلیون بیبی دوج جایزه ببر.
                    </p>

                    {Auth ? (
                      <Link to={"/ehraz"}>
                        <button className="btngift">احراز هویت</button>
                      </Link>
                    ) : (
                      <Link to={"/login"}>
                        <button className="btngift">ثبت نام</button>
                      </Link>
                    )}
                  </div>
                </div>

                <div className="col-4  ">
                  <div className="card-gift2023">
                    <img
                      className="img-gift-size"
                      src="https://static.sinatether.com/images/gift2.svg"
                      alt=""
                    />

                    <div className="title-gift2023">ارز بدون کارمزد بخر!</div>

                    <p className="ksjfsf242929451">
                      شما میتوانی تمامی ارز هارا در سینا تتر بدون کارمزد بخرید.
                    </p>
                    <Link to={"/BTC"}>
                      <button className="btngift">معامله</button>
                    </Link>
                  </div>
                </div>

                <div className="col-4  ">
                  <div className="card-gift2023">
                    <img
                      className="img-gift-size"
                      src="https://static.sinatether.com/images/gift3.svg"
                      alt=""
                    />

                    <div className="title-gift2023">دوستاتو دعوت کن! </div>

                    <p className="ksjfsf242929451">
                      با ارسال لینک دعوت به دوستان خود 200 هزار په په رایگان از
                      سینا تتر بگیر.{" "}
                    </p>

                    {Auth ? (
                      <>
                        <CopyToClipboard text={inviteLink} onCopy={onCopyText}>
                          <div className={"fhjshfcopy"}>
                            <MdContentCopy />
                          </div>
                        </CopyToClipboard>

                        <div className="kfjsfn24253">{inviteLink}</div>
                      </>
                    ) : (
                      <Link to={"/login"}>
                        <button className="btngift">دریافت لینک دعوت</button>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className=" marginrl-140 hjfdsgbf24232">
              <SimpleAccordion data={data} />
            </div>
          </div>

          <div className="just-center  ">
            <div className="lastttx">
              با سینا تتر پازل سرمایه گذاری تو کامل کن !
            </div>

            <div className="mdfhsyfsf354 ">
              <Link to={"/login"}>
                <button className="btn btnsjhrsrbr35">
                  همین الان ثبت نام کن !
                </button>
              </Link>
            </div>
          </div>
        </>
      )}

      <Footer />
    </div>
  );
}
